export const CITATION_LIST_ID = 'citation-list';
